import { render, staticRenderFns } from "./CarouselPortfolio.vue?vue&type=template&id=1a1a7daf&scoped=true&"
import script from "./CarouselPortfolio.vue?vue&type=script&lang=js&"
export * from "./CarouselPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./CarouselPortfolio.vue?vue&type=style&index=0&id=1a1a7daf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a7daf",
  null
  
)

export default component.exports